import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SelectFilterDataModule} from "../../../../../../core/component/select-filter-data/select-filter-data.module";
import {FormDefinitionFieldSelectFilterComponent} from "./form-definition-field-select-filter.component";
import {ReactiveFormsModule} from "@angular/forms";
import {SelectFilterModule} from '../../../../../../../components/common/select-filter/select-filter.module';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        SelectFilterDataModule,
        SelectFilterModule,
    ],
    declarations: [
        FormDefinitionFieldSelectFilterComponent
    ],
    exports: [
        FormDefinitionFieldSelectFilterComponent
    ]
})
export class FormDefinitionFieldSelectFilterModule {
}
